import { clearStoredNavbarStatus, getStoredNavbarStatus, setStoredNavbarStatus, useState,
         useQueryClient, useRouter} from '@/imports-files/hooks/use-navbar';


export function useNavbarStatus() 
{
const [navbarStatus, setNavbarStatus]   =   useState(getStoredNavbarStatus());
const queryClient                       =   useQueryClient();
const router                            =   useRouter();

if( router.pathname.includes('/dashboard/') && navbarStatus == undefined )
{

    var values = {   "selectedSubSidebarOptions":"activities",
                     "selectedParentSubSidebarOptions" :"activities",
                     "key" : "activities"
                 };
    updateNavbarStatus(values);
}

// meant to be called from useAuth
function updateNavbarStatus(newStatusValues) 
{
    // set user in state
    setNavbarStatus(newStatusValues);

    // update user in localstorage
    setStoredNavbarStatus(newStatusValues);

    queryClient.setQueryData('navbarStatus', newStatusValues);
}

// meant to be called from useAuth
function clearNavbarStatus() 
{
    // update state
    setUser(null);

    // remove from localstorage
    clearStoredNavbarStatus();

    queryClient.setQueryData('navbarStatus', null);
    }

    return {navbarStatus, updateNavbarStatus, clearNavbarStatus};
}
